<template>
  <filter-wrapper
    class="string-filter"
    :label="field.label"
    :display-add-value-button="true"
    :removable="removable"
    @removeFilter="removeFilter"
    @addValue="addValue"
  >
    <div class="filter__content__values">
      <div
        class="filter__content__values__value"
        v-for="(value, index) in filterData.field.filter.values"
        :key="index"
      >
        <b-form-input
          type="text"
          v-model="value.value"
          placeholder="Подстрока"
        />
        <b-button
          variant="outline-danger"
          class="filter__content__values__value__remove-button"
          v-b-popover.hover.right="'Удалить значение'"
          @click="removeValue(value)"
        >
          <b-icon icon="x" />
        </b-button>
      </div>
    </div>
  </filter-wrapper>
</template>
<script>
import filterMixin from "@/components/Tables/Filters/mixins/filterMixin";
import FilterWrapper from "@/components/Tables/Filters/FilterWrapper";
export default {
  components: { FilterWrapper },
  mixins: [filterMixin],
  methods: {
    handler(item) {
      let val = item[this.field.key];
      if (typeof this.field.formatter === "function")
        val = this.field.formatter(val, this.field.key, item);
      let searchValues = this.filterData.field.filter.values.filter(
        ({ value }) => value.length > 0
      );
      if (searchValues.length > 0)
        return searchValues.some(({ value }) =>
          val.toLowerCase().includes(value.toLowerCase())
        );
      else return true;
    },
    addValue() {
      this.filterData.field.filter.values.push({ value: "" });
    },
    removeValue(value) {
      this.filterData.field.filter.values.splice(
        this.filterData.field.filter.values.indexOf(value),
        1
      );
    }
  }
};
</script>
